import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const BASKET = "#9a6b3a";
const BASKET_RIM = "#7a5230";
const BERRY = "#b1324a";
const BERRY_HI = "#d2566c";

function berryBasket(cx: number, cy: number, cz: number, s: number): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(s, s * 0.78, s * 0.8, 9), color: BASKET, position: [cx, cy, cz] },
    { geometry: new THREE.CylinderGeometry(s * 1.04, s * 1.04, 0.016, 9), color: BASKET_RIM, position: [cx, cy + s * 0.36, cz] },
    { geometry: new THREE.IcosahedronGeometry(s * 0.78, 0), color: BERRY, position: [cx, cy + s * 0.5, cz], scale: [1, 0.55, 1] as const },
    { geometry: new THREE.IcosahedronGeometry(s * 0.3, 0), color: BERRY_HI, position: [cx + s * 0.3, cy + s * 0.6, cz - s * 0.2] },
  ];
}

export const berryBasketModel = defineModel({
  id: "berry-basket",
  batchId: "characters",
  name: "Berry basket",
  tags: ["good", "cargo", "food"],
  fits: ["carry"],
  summary: "A wicker basket of berries -- a carriable good for an avatar's carry socket.",
  description:
    "A small wicker basket filled with berries at held scale, ported from " +
    "age-of-mcp's goods (`berries`). Mount it in a player's or worker's `carry` " +
    "socket to show the figure hauling berries.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => berryBasket(0, 0.04, 0.02, 0.07),
  animations: [],
});
